import * as React from 'react';
import DetailsSection from 'nomst/Components/SharedJobCollab/detailsSection';
import { DetailsCard } from 'nomst/Components/SharedJobCollab/detailsCard';
import { mxStrings } from 'utils/JobCollabStrings';
import './jobMatchSection.scss';

interface JobMatchSectionProps {
    payscaleJobTitle?: string;
    jobTasks?: Nullable<string[]>;
    fullSection: boolean;
}

class JobMatchSection extends React.Component<JobMatchSectionProps, {}> {

    render(): React.ReactNode {
        const { payscaleJobTitle, jobTasks, fullSection } = this.props;

        // If no job title then by def we will not have a task description
        // so show nothing in that case
        if (!payscaleJobTitle) {
            return null;
        }

        const hasTasks = !!jobTasks?.length;

        return fullSection ? this._renderFullDetailsSection(payscaleJobTitle, hasTasks, jobTasks || []) :
            this._renderSection(mxStrings.payscaleJobMatchJobReviewSubTitle,
                payscaleJobTitle,
                'job-match job-match-spacing');
    }

    private _renderSection(header: string, body: string, className?: string): React.ReactNode {
        return <DetailsCard title={header} className={className}>
            <div className="job-match-body pxl-small">
                <span>{ body }</span>
            </div>
        </DetailsCard>;
    }

    private _renderFullDetailsSection(payscaleJobTitle: string, hasTasks: boolean, jobTasks: string[]): React.ReactNode {
        return <DetailsSection
            title={mxStrings.payscaleJobMatchTitle}
            className="job-match"
        >
            { this._renderSection(
                mxStrings.payscaleJobMatchSubTitle,
                payscaleJobTitle,
                'job-match-title-section') }
            { hasTasks && this._renderSection(
                mxStrings.payscaleJobMatchTaskTitle,
                jobTasks.join(' '),
                'job-match-task-section') }
        </DetailsSection>;
    }
}

export { JobMatchSection };
export default JobMatchSection;